/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityPhoneRequest
 */
export interface UpdateFacilityPhoneRequest {
    /**
     * 
     */
    primary_phone: string;
}

/**
 * Check if a given object implements the UpdateFacilityPhoneRequest interface.
 */
export function instanceOfUpdateFacilityPhoneRequest(value: object): value is UpdateFacilityPhoneRequest {
    if (!('primary_phone' in value) || value['primary_phone'] === undefined) return false;
    return true;
}

export function UpdateFacilityPhoneRequestFromJSON(json: any): UpdateFacilityPhoneRequest {
    return UpdateFacilityPhoneRequestFromJSONTyped(json, false);
}

export function UpdateFacilityPhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityPhoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'primary_phone': json['primary_phone'],
    };
}

export function UpdateFacilityPhoneRequestToJSON(json: any): UpdateFacilityPhoneRequest {
    return UpdateFacilityPhoneRequestToJSONTyped(json, false);
}

export function UpdateFacilityPhoneRequestToJSONTyped(value?: UpdateFacilityPhoneRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary_phone': value['primary_phone'],
    };
}

